import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Slider from "react-slick";
import ImageLoader from "react-loading-image";
import _ from "lodash";
import "./index.css";

class NoteObservationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showObservationPhotosModal: false
    };
  }

  renderHeader = () => {
    const { observationIndex, observationCount } = this.props;
    if (observationCount > 1) {
      return (
        <h3>
          Observation Summary {observationIndex} of {observationCount}
        </h3>
      );
    } else {
      return <h3>Observation Summary</h3>;
    }
  };

  handleClose = () => {
    this.setState({ showObservationPhotoModal: false });
  };

  openPhotosModal = () => {
    this.setState({ showObservationPhotoModal: true });
  };

  openPhoto = (item, key) => {
    return (
      <div key={key}>
        <ImageLoader
          src={item.image_file}
          loading={() => <div className="loading-con">Loading image...</div>}
          error={() => <div>There was error loading the image.</div>}
          className="img-responsive center-block"
        />
      </div>
    );
  };

  renderPhotos = () => {
    const { observation } = this.props;
    const photos = [];

    _.each(observation.photos, (item, key) => {
      photos.push(this.openPhoto(item, key));
    });

    return photos;
  };

  renderPhotosModal = showObservationPhotosModal => {
    const { observation } = this.props;
    const settings = {
      dots: !showObservationPhotosModal ? false : true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true
    };

    return (
      <div className="modal-container container-fluid">
        <Modal show={showObservationPhotosModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{`Photos for Observation #${observation.id}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="slider-container">
              <Slider {...settings}>{this.renderPhotos()}</Slider>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  };

  renderSummary = () => {
    const { observation } = this.props;
    return <div>{observation.description}</div>;
  };

  renderViewPhotosLink = () => {
    const { observation } = this.props;

    if (observation.photos.length < 1) {
      return null;
    }

    return (
      <a className="link" onClick={this.openPhotosModal}>
        View photos
      </a>
    );
  };

  render = () => {
    const { showObservationPhotoModal } = this.state;

    return (
      <div className="noteObservationMainPanel">
        <div className="observation-header">{this.renderHeader()}</div>
        <div className="observation-summary">{this.renderSummary()}</div>
        <div className="observation-photos">{this.renderViewPhotosLink()}</div>
        {this.renderPhotosModal(showObservationPhotoModal)}
      </div>
    );
  };
}

export default NoteObservationCard;



// WEBPACK FOOTER //
// ./src/_components/NoteObservationCard/index.js